import { lazy } from 'react';
import schema from '../model/schema';
import config from '../config.json';

const RemoteControlButton = lazy(() => import('./remote-control-button'));

const RemoteControl = () => {
  const params = new URLSearchParams(window.location.search);
  const paramObj = Object.fromEntries(params.entries());
  const { label } = config;

  const { success, data } = schema.safeParse(paramObj);

  if (success) return <RemoteControlButton returnUrl={data.returnUrlManage} label={label} />;

  return null;
};

export default RemoteControl;
